import React from 'react';
import { openInfoWindow } from '../../utils/openInfoWindow';

class InfoWindow extends React.PureComponent {
    render() {
        return ([
            openInfoWindow(
                this.props.marker,
                this.props.userPos, 
                this.props.map,
                this.props.infowindow,
                this.props.labels,
                this.props.services,
                this.props.language,
                this.props.onClose,
            )
        ])
    }
}

export default InfoWindow;
